import { render } from "./kcjr.vue?vue&type=template&id=ff4b609e&scoped=true"
import script from "./kcjr.vue?vue&type=script&lang=js"
export * from "./kcjr.vue?vue&type=script&lang=js"

import "./kcjr.vue?vue&type=style&index=0&id=ff4b609e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff4b609e"]])

export default __exports__